import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
// import { orderBy, isEmpty, sortBy } from "lodash";

// import DropdownSearch from "../../common/DropdownSearch";

import ReportFilters from "../ReportFiltersComponent";

import CallTypeSelect from "../../common/CallTypeSelect";

const Filters = ({
  onChange,
  filters,
  onResetClick,
  onFetchClick,
  loading,
  disabled,
  exportDisabled,
  onCSVExport
}) => (
  <ReportFilters
    onFetchClick={onFetchClick}
    onResetClick={onResetClick}
    title="Customer Annual Revenue Analysis"
    loading={loading}
    disabled={disabled}
    csvExportAvailable
    exportDisabled={exportDisabled}
    onCSVExport={onCSVExport}
  >
    <Row>
      <Col md={3}>
        <CallTypeSelect
          label="Call Type"
          placeholder="Select"
          isMulti
          onChange={onChange("call_type")}
          value={filters.call_type}
        />
      </Col>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          Start Date
        </label>
        <input
          style={{
            padding: 8,
            border: "1px solid hsl(0,0%,80%)",
            width: "100%",
            borderRadius: 4
          }}
          type="date"
          value={filters.start_date}
          onChange={(e) => onChange("start_date")(e.target.value)}
        />
      </Col>
      <Col md={3}>
        <label className="control-label" style={{ textTransform: "uppercase" }}>
          End Date
        </label>
        <input
          style={{
            padding: 8,
            border: "1px solid hsl(0,0%,80%)",
            width: "100%",
            borderRadius: 4
          }}
          type="date"
          onChange={(e) => onChange("end_date")(e.target.value)}
          value={filters.end_date}
        />
      </Col>
    </Row>
  </ReportFilters>
);
Filters.propTypes = {
  onChange: PropTypes.func,
  filters: PropTypes.object,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onResetClick: PropTypes.func,
  onFetchClick: PropTypes.func,
  exportDisabled: PropTypes.func,
  onCSVExport: PropTypes.func
};
export default Filters;
